import React from 'react';
import styles from '../styles/FAQSection.module.css';

const FAQSection = () => {
  const faqs = [
    {
      question: '什么是AI镜像账户？',
      answer: 'AI镜像账户是指我们为您提供的能够访问各类AI平台和服务的账户，无需繁琐的注册和验证过程，立即使用先进的AI技术。',
    },
    {
      question: '如何选择适合我的账户？',
      answer: '您可以根据自己的需求选择不同的账户类型。如果您是初次使用，建议选择基础账户；如果需要更多功能，可以选择高级账户或企业账户。',
    },
    {
      question: '账户有效期是多久？',
      answer: '我们提供的镜像账户根据不同类型有不同的有效期，基本从1个月到1年不等。详细信息请查看各账户的详情页面。',
    },
    {
      question: '如何获取技术支持？',
      answer: '您可以通过网站底部的联系方式或在账户中心提交工单获取技术支持。我们的客服团队会在24小时内回复您的问题。',
    },
  ];

  return (
    <section id="faq" className={styles.faqSection}>
      <div className={styles.container}>
        <h2>常见问题</h2>
        <div className={styles.faqGrid}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.faqItem}>
              <div className={styles.faqQuestion}>
                <i className="fas fa-question-circle"></i>
                <span>{faq.question}</span>
              </div>
              <div className={styles.faqAnswer}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;